import image from 'src/assets/img/channel_revcontent.png';
import ImageIcon from 'src/components/ImageIcon';

export const IconChannelRevcontent = (props) => (
  <ImageIcon
    image={image}
    {...props}
  />
);
